import React from 'react'
import { Box, Card as MuiCard, CardContent as MuiCardContent } from '@mui/material'
import { useTranslation } from 'react-i18next'

// CommonCard component with same styling as other reading components
const CommonCard = ({ children, sx = {} }: { children: React.ReactNode; sx?: any }) => (
  <MuiCard
    sx={{
      bgcolor: 'rgba(255, 255, 255, 0.7)',
      backdropFilter: 'blur-sm',
      border: '0.5px solid rgba(201, 173, 167, 0.4)',
      borderRadius: '0.5rem',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      transition: 'all 200ms',
      marginBottom: 8,
      '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
      },
      ...sx
    }}
  >
    {children}
  </MuiCard>
)

interface PracticalAdvice {
  title: string
  content?: string
}

interface PracticalAdviceSectionProps {
  practicalAdvice?: PracticalAdvice[]
}

export default function PracticalAdviceSection({
  practicalAdvice = []
}: PracticalAdviceSectionProps) {
  const { t } = useTranslation()

  if (!practicalAdvice || practicalAdvice.length === 0) {
    return null
  }

  return (
    <section aria-labelledby="advice-heading">
      <h2
        id="advice-heading"
        className="text-lg font-['Playfair_Display'] text-[#2B2E4A] font-semibold mb-2 mt-0 m-0"
      >
        {t('readingPage.practicalAdvice')}
      </h2>
      <Box sx={{ mb: 0 }}>
        {practicalAdvice.map((advice: PracticalAdvice, index: number) => (
          <CommonCard key={index} sx={{ mb: 4 }}>
            <MuiCardContent>
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 rounded-full bg-[#2B2E4A]/10 flex items-center justify-center shrink-0 ">
                  <span className="text-lg text-[#2B2E4A] font-medium">{index + 1}</span>
                </div>
                <div className="flex flex-col gap-1">
                  <p className="text-lg font-semibold text-[#2B2E4A] mb-2 leading-relaxed font-['Playfair_Display']">
                    {advice?.title}
                  </p>
                  {advice?.content && (
                    <p className="text-md leading-relaxed text-[#2B2E4A]/70 font-['Plus_Jakarta_Sans']">
                      {advice?.content}
                    </p>
                  )}
                </div>
              </div>
            </MuiCardContent>
          </CommonCard>
        ))}
      </Box>
    </section>
  )
}
